import { checkIsFiltered } from '@/lib/utils/algolia'

import GridArchiveItems from '@/components/grid-archive/GridArchiveItems'
import { GridViewLink } from '@/components/grid-archive/GridViewLink'
import FilterToolbar from '@/components/filters/FilterToolbar'
import FilterModal from '@/components/filters/FilterModal'
import FilterModalFooter from '@/components/filters/FilterModalFooter'
import FilterModalComponents from '@/components/filters/FilterModalComponents'
import FilterRefinementPillboxList from '@/components/filters/FilterRefinementPillboxList'
import FilterStats from '@/components/filters/FilterStats'
import FilterSearchBox from '@/components/filters/FilterSearchBox'
import FilterPagination from '@/components/filters/FilterPagination'
import FilterVirtualRefinementList from '@/components/filters/FilterVirtualRefinementList'

import type { ArchiveAPIResponseType, FilterPropsType } from '@/layouts/types'

export default function GridArchiveInner({
  filters,
  pillFilter,
  pinnedPost,
  gridRef,
  featuredIds,
  featuredContent,
  featuredRendered,
  disableFilters,
  disableFeatured,
  pathname,
}: {
  filters: FilterPropsType
  pillFilter: ArchiveAPIResponseType['archive_prominent_filters']
  pinnedPost: ArchiveAPIResponseType['archive_pinned_post']
  gridRef: React.RefObject<HTMLDivElement>
  featuredIds: string[]
  featuredContent: React.ReactNode
  featuredRendered: boolean
  disableFilters?: boolean
  disableFeatured?: boolean
  pathname?: string
}) {
  const isFiltered = checkIsFiltered()
  const hasArchiveFilters = !disableFilters && filters?.length > 0

  return (
    <>
      {hasArchiveFilters ? (
        <div className="hidden" aria-hidden="true">
          <FilterModalComponents filters={filters} />
        </div>
      ) : null}

      <div className="container py-l">
        {!disableFilters ? (
          <FilterVirtualRefinementList attribute={'authors_taxonomy.name'} />
        ) : null}

        <FilterToolbar
          leftChildren={
            hasArchiveFilters ? (
              <div className="flex w-full items-center gap-x-s">
                <FilterModal footerComponent={<FilterModalFooter />}>
                  <FilterModalComponents filters={filters} />
                </FilterModal>

                {pillFilter ? (
                  <nav className="flex w-full items-center justify-between gap-x-s">
                    <FilterRefinementPillboxList filters={pillFilter} className="m:hidden" />
                  </nav>
                ) : null}
              </div>
            ) : null
          }
          rightChildren={
            <div className={`flex w-full justify-end gap-x-s`}>
              <FilterSearchBox />

              {!disableFilters && pathname?.includes('/events/') ? (
                <GridViewLink
                  tooltipText="Calendar view"
                  link="/events/calendar/"
                  iconId="icon-calendar"
                />
              ) : null}
            </div>
          }
        />
      </div>

      {/* Featured items - rendered after filter bar */}
      {featuredContent}

      <>
        {!isFiltered && pinnedPost ? <div className="container mb-l">{pinnedPost}</div> : null}

        {/* Wait until exclusion IDs are set (or not) and then render remaining results */}
        {featuredRendered ? (
          <>
            <div
              className="container grid grid-cols-1 gap-y-xl"
              ref={gridRef}
              style={{ scrollMarginTop: '80px' }}>
              <GridArchiveItems
                isFiltered={isFiltered}
                featuredIds={featuredIds}
                disableFeatured={disableFeatured}
              />
            </div>

            <div className="my-m border-t pt-m text-center">
              <div className="container flex items-center justify-between ms:flex-col ms:gap-y-s">
                <FilterStats />
                <FilterPagination gridRef={gridRef} />
              </div>
            </div>
          </>
        ) : null}
      </>
    </>
  )
}
